<template>
	<div class="page" v-loading="loadingPage">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<div>
				<el-button type="success" size="small" round @click="employeeAddVisible = true">
					<span class="el-icon-user"></span>
					添加人员
				</el-button>
			</div>
		</div>
		<div class="page-main">
			<el-card class="box-card" :body-style="{ padding: 0 }">
				<div class="flex justify-between">
					<div style="width: 380px;">
						<el-card shadow="never" :body-style="{ padding: '10px' }">
							<div slot="header" class="flex justify-between align-center">
								<div class="flex align-center">
									<span class="iconfont-bumen"></span>
									<span class="text-bold margin-left-sm">组织架构</span>
								</div>
								<el-button type="success" size="mini" round class="margin-left" @click="dialogVisibleDeptAdd = true">
									<span class="el-icon-plus"></span>
									创建部门
								</el-button>
							</div>
							<el-tree
								ref="deptTree"
								:data="departmentTreeData"
								:expand-on-click-node="false"
								:props="{ label: 'name' }"
								:default-expand-all="true"
								:highlight-current="true"
								node-key="id"
								:current-node-key="department_info.id"
								:default-checked-keys="[department_info.id]"
								@node-click="handleNodeClick"
								:indent="0"
								:draggable="true"
								@node-drop="handleDrop"
								class="tree-line tree-menu"
							>
								<span class="text-df" slot-scope="{ node, data }">
									<span>{{ data.name }}</span>
									<el-tag size="mini" type="info" class="margin-left-xs" v-if="data.stateflag == 0">已解散</el-tag>
								</span>
							</el-tree>
						</el-card>
					</div>
					<div style="width: 100%;">
						<el-card class="" :body-style="{ padding: 0 }" shadow="never">
							<div slot="header">
								<div class="flex justify-between align-center">
									<div class="flex align-center">
										<div class="title flex align-center">
											<span class="iconfont-yuangong"></span>
											<span class="text-bold margin-left-xs">{{ department_info.name }}</span>
											<span class="padding-left-xs text-grey">[ {{ department_info.id }} ]</span>
										</div>
										<div class="action" v-if="department_info.stateflag == 1">
											<el-button type="warning" size="mini" class="margin-left" @click="dialogVisibleDeptModify = true">
												<span class="el-icon-edit"></span>
												修改部门
											</el-button>
											<el-button type="primary" size="mini" class="margin-left" @click="setLeader">
												<span class="el-icon-s-custom"></span>
												设置上级
											</el-button>
										</div>
										<div class="action" v-else>
											<el-button type="info" size="mini" class="margin-left" @click="deleteDept(department_info)" v-if="department_info.id != 1">
												<span class="el-icon-delete"></span>
												删除
											</el-button>
										</div>
									</div>
									<div class="flex align-center">
										<div class="searchForm margin-left">
											<el-checkbox v-model="formSearch.data.has_leave" :true-label="1" :false-label="0" @change="getEmployeeInfoList">包含已离职</el-checkbox>
											<el-checkbox v-model="formSearch.data.has_children" :true-label="1" :false-label="0" @change="getEmployeeInfoList">
												包含子部门
											</el-checkbox>
										</div>
									</div>
								</div>
							</div>
							<el-table
								:data="employeeInfoList"
								style="width: 100%"
								stripe
								v-loading="loading"
								element-loading-text="加载中..."
								element-loading-spinner="el-icon-loading"
							>
								<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
								<el-table-column align="center" label="头像" width="180">
									<template slot-scope="scope">
										<el-avatar :size="48" :src="scope.row.avatar"></el-avatar>
									</template>
								</el-table-column>
								<el-table-column align="center" label="姓名">
									<template slot-scope="scope">
										<span v-if="scope.row.gender == 1" class="text-blue text-bold">
											{{ scope.row.name }}
											<sup class="bg-blue round sm">
											<i class="el-icon-male"></i>
											</sup>
										</span>
										<span v-else-if="scope.row.gender == 2" class="text-pink text-bold">
											{{ scope.row.name }}
											<sup class="bg-pink round sm">
											<span class="el-icon-female"></span>
											</sup>
										</span>
										<span v-else class="text-black text-bold">{{ scope.row.name }}</span>
										<el-tag type="warning" effect="plain" size="mini" class="margin-left" v-if="scope.row.is_leader">主管</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="position" align="center" label="职务"></el-table-column>
								<el-table-column prop="officeid" align="center" label="工号"></el-table-column>
								<el-table-column prop="jointime" align="center" label="入职时间" width="180"></el-table-column>
								<el-table-column prop="type" align="center" label="状态" width="120">
									<template slot-scope="scope">
										<span v-if="scope.row.stateflag == 1" class="cu-tag bg-olive radius">在职</span>
										<span v-else-if="scope.row.stateflag == 0" class="cu-tag bg-gray radius">离职</span>
										<span v-else class="cu-tag bg-red radius">未知</span>
									</template>
								</el-table-column>
								<el-table-column prop="addtime" align="center" label="创建时间" width="180"></el-table-column>
								<el-table-column align="center" label="操作" width="120">
									<template slot-scope="scope">
										<el-button size="small" type="primary" @click="viewEmployeeInfo(scope.row.user_id)">查看</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="padding text-right">
								<el-pagination
									background
									@size-change="pageSizeChange"
									@current-change="pageChange"
									:current-page="formSearch.page"
									:page-sizes="[10, 20, 50, 100]"
									:page-size="formSearch.size"
									layout="total, sizes, prev, pager, next, jumper"
									:total="total"
									getCurrentKey="getCurrentKey"
								></el-pagination>
							</div>
						</el-card>
					</div>
				</div>
			</el-card>
			<!-- 设置部门主管 -->
			<el-dialog title="设置部门主管" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleSetLeader" width="600px">
				<div v-loading="loadingSetLeader">
					<el-table :data="employeeInfoList" style="width: 100%" stripe v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
						<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
						<el-table-column align="center" label="姓名">
							<template slot-scope="scope">
								<span v-if="scope.row.gender == 1" class="text-blue text-bold">{{ scope.row.name }}</span>
								<span v-else-if="scope.row.gender == 2" class="text-pink text-bold">{{ scope.row.name }}</span>
								<span v-else class="text-black text-bold">{{ scope.row.name }}</span>
								<el-tag type="warning" effect="plain" size="mini" class="margin-left-xs" v-if="scope.row.is_leader">主管</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="position" align="center" label="职务"></el-table-column>
						<el-table-column prop="officeid" align="center" label="工号"></el-table-column>
						<el-table-column align="center" label="操作" width="120">
							<template slot-scope="scope">
								<el-button size="mini" round @click="setLeaderAction(scope.row.user_id, department_info.id)" v-if="scope.row.is_leader">取消设置</el-button>
								<el-button size="mini" type="warning" round @click="setLeaderAction(scope.row.user_id, department_info.id)" v-else>设为主管</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-dialog>
			<!-- 添加部门 -->
			<el-dialog title="创建部门" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleDeptAdd" width="500px">
				<div style="overflow: auto;" class="padding-lr">
					<el-form ref="formDeptAdd" :model="formDeptAdd" label-suffix=":" label-width="100px">
						<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入部门名称', trigger: 'blur' }">
							<el-input v-model="formDeptAdd.name" placeholder="部门名称" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="别名" prop="name_en">
							<el-input v-model="formDeptAdd.name_en" placeholder="英文或其他叫法" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="上级部门" prop="parentid">
							<el-button @click="showCheckSingleDeptAdd = true">
								<span v-if="formDeptAdd.department.name" class="text-blue">{{ formDeptAdd.department.name }}</span>
								<span v-else>点击选择</span>
								<span class="el-icon-more margin-left-xs"></span>
							</el-button>
						</el-form-item>

						<el-form-item label="成立日期" prop="creat_time">
							<el-date-picker type="date" placeholder="选择日期" v-model="formDeptAdd.creat_time"></el-date-picker>
						</el-form-item>
						<el-form-item label="状态"><el-switch v-model="formDeptAdd.stateflag" :active-value="1" :inactive-value="0"></el-switch></el-form-item>
						<el-form-item label="撤销时间" prop="cancel_time" v-if="!formDeptAdd.stateflag">
							<el-date-picker type="date" placeholder="选择日期" v-model="formDeptAdd.cancel_time"></el-date-picker>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisibleDeptAdd = false">取 消</el-button>
					<el-button type="primary" @click="formSubmitDeptAdd()">确 定</el-button>
				</div>
			</el-dialog>
			<!-- 修改部门 -->
			<el-dialog title="修改部门信息" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleDeptModify" width="500px">
				<div style="overflow: auto;" class="padding-lr">
					<el-form ref="formDeptModify" :model="formDeptModify" label-suffix=":" label-width="100px">
						<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入部门名称', trigger: 'blur' }">
							<el-input v-model="formDeptModify.name" placeholder="部门名称" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="别名" prop="name_en">
							<el-input v-model="formDeptModify.name_en" placeholder="英文或其他叫法" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="上级部门" prop="parentid" v-if="formDeptModify.parentid">
							<el-button @click="showCheckSingleDeptModify = true">
								<span v-if="formDeptModify.parent" class="text-blue">{{ formDeptModify.parent.name }}</span>
								<span v-else>点击选择</span>
								<span class="el-icon-more margin-left-xs"></span>
							</el-button>
						</el-form-item>
						<el-form-item label="成立日期" prop="creat_time">
							<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formDeptModify.creat_time"></el-date-picker>
						</el-form-item>
						<el-form-item label="状态"><el-switch v-model="formDeptModify.stateflag" :active-value="1" :inactive-value="0"></el-switch></el-form-item>
						<el-form-item label="撤销时间" prop="cancel_time" v-if="!formDeptModify.stateflag">
							<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formDeptModify.cancel_time"></el-date-picker>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisibleDeptModify = false">取 消</el-button>
					<el-button type="primary" @click="formSubmitDeptModify()">确 定</el-button>
				</div>
			</el-dialog>
			<!-- 添加人员 -->
			<employee-add :visible="employeeAddVisible" @close="employeeAddVisible = false" @success="addEmployeeSuccess"></employee-add>
			<!-- 查看人员 -->
			<employee-view :visible="employeeViewVisible" :userId="userId" @close="employeeViewVisible = false"></employee-view>
			<!-- 修改人员 -->
			<el-dialog title="修改人员信息" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleModify">
				<div style="height: 60vh; overflow: auto;" class="padding-lr">
					<el-form ref="formModifyEmployee" :model="formModifyEmployee" label-suffix=":" label-width="100px">
						<el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请输入活动名称', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.name" placeholder="身份证上的姓名" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="性别">
							<el-radio-group v-model="formModifyEmployee.gender">
								<el-radio :label="1">男</el-radio>
								<el-radio :label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="民族" prop="people" :rules="{ required: true, message: '请输入民族', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.people" placeholder="民族" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="籍贯" prop="birthplace" :rules="{ required: true, message: '请输入籍贯', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.birthplace" placeholder="籍贯,一般指出生地" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="婚姻">
							<el-radio-group v-model="formModifyEmployee.marriage">
								<el-radio :label="1">已婚</el-radio>
								<el-radio :label="0">未婚</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="身份证号" prop="idcard" :rules="{ required: true, message: '请输入身份证号', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.idcard" placeholder="身份证号码" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="生日" prop="birthday" :rules="{ required: true, message: '请选择出生日期', trigger: 'blur' }">
							<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formModifyEmployee.birthday"></el-date-picker>
						</el-form-item>
						<el-form-item label="手机号码" prop="mobile" :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.mobile" placeholder="手机号码" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="微信号码" prop="weixin">
							<el-input v-model="formModifyEmployee.weixin" placeholder="可以搜索到微信的号码" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="QQ" prop="qq"><el-input v-model="formModifyEmployee.qq" placeholder="QQ号码" style="width: 220px;"></el-input></el-form-item>
						<el-form-item label="邮箱" prop="email"><el-input v-model="formModifyEmployee.email" placeholder="QQ号码" style="width: 220px;"></el-input></el-form-item>
						<el-form-item label="住址" prop="address" :rules="{ required: true, message: '请输入现居住住址', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.address" placeholder="现居住地址,精确到具体门牌号" style="width: 80%;"></el-input>
						</el-form-item>
						<el-form-item label="紧急联系人" prop="linkman.name">
							<el-input v-model="formModifyEmployee.linkman.name" placeholder="姓名" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="" prop="linkman.gx">
							<el-input v-model="formModifyEmployee.linkman.gx" placeholder="关系" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="" prop="linkman.mobile">
							<el-input v-model="formModifyEmployee.linkman.mobile" placeholder="手机号码" style="width: 220px;"></el-input>
						</el-form-item>
						<el-divider content-position="left">工作信息</el-divider>
						<el-form-item label="所属部门">
							<el-popover :key="dept.id" v-for="dept in formModifyEmployee.departmentArr" placement="top" width="160">
								<div class="solid-bottom text-center" v-if="!dept.is_main">
									<el-button @click="setMainDepartmentModify(dept)" type="text">设为主部门</el-button>
								</div>
								<div class="text-center"><el-button type="text" @click="delDepartmentModify(dept)" class="text-grey">删除</el-button></div>
								<span slot="reference" class="">
									<el-button type="primary" size="small" :plain="!dept.is_main" class="margin-right">
										<span class="iconfont-bumen"></span>
										{{ dept.name }}
									</el-button>
								</span>
							</el-popover>
							<el-button size="small" @click="dialogVisibleCheckDepartmentModify = true">
								<span class="iconfont-bumen"></span>
								选择/修改
							</el-button>
						</el-form-item>
						<el-form-item label="工号" prop="officeid" :rules="{ required: true, message: '请输入工号', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.officeid" placeholder="工号" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="职务" prop="position" :rules="{ required: true, message: '请输入职务', trigger: 'blur' }">
							<el-input v-model="formModifyEmployee.position" placeholder="职务" style="width: 220px;"></el-input>
						</el-form-item>
						<el-form-item label="是否在职"><el-switch v-model="formModifyEmployee.stateflag" :active-value="1" :inactive-value="0"></el-switch></el-form-item>
						<el-form-item label="入职时间" prop="jointime" :rules="{ required: true, message: '请选择入职时间', trigger: 'blur' }">
							<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formModifyEmployee.jointime"></el-date-picker>
						</el-form-item>
						<el-form-item
							label="离职时间"
							prop="leavetime"
							:rules="{ required: true, message: '请选择离职时间', trigger: 'blur' }"
							v-if="formModifyEmployee.stateflag == 0"
						>
							<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formModifyEmployee.leavetime"></el-date-picker>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisibleModify = false">取 消</el-button>
					<el-button type="primary" @click="formSubmitModify">确 定</el-button>
				</div>
			</el-dialog>
			<el-dialog title="选择部门" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleCheckDepartment" width="350px">
				<div style="height: 60vh; overflow: auto;">
					<el-tree
						ref="treeCheckDepartment"
						:data="departmentTreeData"
						:expand-on-click-node="false"
						:props="{ label: 'name' }"
						:default-expand-all="true"
						:highlight-current="true"
						node-key="id"
						check-strictly
						:indent="0"
						check-on-click-node
						show-checkbox
						class="tree-line"
					></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisibleCheckDepartment = false">取 消</el-button>
					<el-button type="primary" @click="checkDept">确 定</el-button>
				</div>
			</el-dialog>
			<el-dialog title="选择部门" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleCheckDepartmentModify" width="350px">
				<div style="height: 60vh; overflow: auto;">
					<el-tree
						ref="treeCheckDepartmentModify"
						:data="departmentTreeData"
						:expand-on-click-node="false"
						:props="{ label: 'name' }"
						:default-expand-all="true"
						:highlight-current="true"
						node-key="id"
						check-strictly
						:indent="0"
						:default-checked-keys="formModifyEmployee.department"
						check-on-click-node
						show-checkbox
						class="tree-line"
					></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisibleCheckDepartmentModify = false">取 消</el-button>
					<el-button type="primary" @click="checkDeptModify">确 定</el-button>
				</div>
			</el-dialog>
			<el-dialog title="选择部门[单选]" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showCheckSingleDeptAdd" width="350px">
				<div style="height: 60vh; overflow: auto;"><check-department-single @check="checkDeptSingleDeptAdd" :data="departmentTreeData"></check-department-single></div>
			</el-dialog>
			<el-dialog title="选择部门[单选]" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showCheckSingleDeptModify" width="350px">
				<div style="height: 60vh; overflow: auto;"><check-department-single @check="checkDeptSingleDeptModify" :data="departmentTreeData"></check-department-single></div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import checkDepartmentSingle from '@/components/check-department-single.vue';
import employeeAdd from './components/employee-add.vue';
import employeeView from './components/employee-view.vue';

export default {
	components: { checkDepartmentSingle, employeeAdd, employeeView },
	data() {
		return {
			loadingPage: false,
			departmentTreeData: [],
			infos_state: [],
			dialogVisibleDeptAdd: false,
			dialogVisibleDeptModify: false,
			showCheckSingleDeptAdd: false,
			showCheckSingleDeptModify: false,
			formDeptAdd: {
				stateflag: 1,
				department: {}
			},
			formDeptModify: {
				parent: {}
			},
			formSearch: {
				page: 1,
				size: 10,
				data: {}
			},
			total: 0,
			loading: false,
			employeeInfoList: [],
			dialogVisibleSetLeader: false,
			loadingSetLeader: false,
			department_info: {},
			employeeAddVisible: false,
			formAdd: {
				gender: 1,
				marriage: 0,
				linkman: {},
				stateflag: 1,
				user: {
					stateflag: 1
				},
				qywx: {},
				dd: {}
			},
			employeeViewVisible: false,
			userId:"",
			loadingView: false,
			dialogResultMsgView: '',
			infoEmployee: {
				linkman: {},
				department: [],
				user: {}
			},
			dialogVisibleModify: false,
			formModifyEmployee: {
				linkman: {},
				department: [],
				user: {}
			},
			dialogVisibleCheckDepartmentModify: false,
			dialogVisibleCheckDepartment: false,
			departmentAdd: []
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getDepartmentTreeData();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		setLeader() {
			this.formSearch.data.has_leave = 0;
			this.formSearch.data.has_children = 0;
			this.dialogVisibleSetLeader = true;
			this.getEmployeeInfoList();
		},
		setLeaderAction(uId, deptId) {
			this.loadingSetLeader = true;
			this.$http.post('/server/index.php?m=hr/department&a=setLeader', { data: { uid: uId, deptid: deptId } }).then(
				res => {
					this.loadingSetLeader = false;
					if (typeof res.data != 'object') {
						this.$alert(res.data ? res.data : '(无返回数据)', {
							title: '返回数据格式错误',
							type: 'error'
						});
					} else {
						if (res.data.result == 'ok') {
							this.getEmployeeInfoList();
							this.$message({
								message: '操作成功！',
								type: 'success',
								onClose: () => {}
							});
						} else {
							this.$alert(res.data.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					}
				},
				r => {
					this.loadingSetLeader = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		deleteDept(dept) {
			this.$confirm('确定要删除部门【' + dept.name + '】吗？请确保下级部门已删除且不存在在职人员', '操作确认', {
				type: 'warning',
				callback: r => {
					if (r == 'confirm') {
						const loading = this.$loading({
							lock: true,
							text: '处理中...',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						this.$http.post('/server/index.php?m=hr/department&a=deleteDept', { data: { id: dept.id } }).then(
							res => {
								loading.close();
								if (typeof res.data != 'object') {
									this.$alert(res.data ? res.data : '(无返回数据)', {
										title: '返回数据格式错误',
										type: 'error'
									});
								} else {
									if (res.data.result == 'ok') {
										this.getDepartmentTreeData();
										this.$message({
											message: '操作成功！',
											type: 'success',
											onClose: () => {}
										});
									} else {
										this.$alert(res.data.msg, {
											title: '操作错误',
											type: 'error'
										});
									}
								}
							},
							r => {
								loading.close();
								this.$alert('网络错误，指定的服务无法访问。', {
									title: '系统错误',
									type: 'error'
								});
							}
						);
					}
				}
			});
		},
		checkDeptSingleDeptAdd(e) {
			this.formDeptAdd.department = { id: e.id, name: e.name };
			this.formDeptAdd.parentid = e.id;
			this.showCheckSingleDeptAdd = false;
		},
		checkDeptSingleDeptModify(e) {
			this.formDeptModify.parent = { id: e.id, name: e.name };
			this.formDeptModify.parentid = e.id;
			this.showCheckSingleDeptModify = false;
			console.log(e);
		},
		formSubmitDeptAdd() {
			this.$refs['formDeptAdd'].validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=hr/department&a=addDept', { data: this.formDeptAdd }).then(
						res => {
							loading.close();
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$alert('部门创建成功！', {
										title: '操作成功',
										type: 'success',
										callback: () => {
											this.dialogVisibleDeptAdd = false;
											this.getDepartmentTreeData();
										}
									});
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		formSubmitDeptModify() {
			this.$refs['formDeptModify'].validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=hr/department&a=modifyDept', { data: this.formDeptModify }).then(
						res => {
							loading.close();
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$alert('部门信息修改成功！', {
										title: '操作成功',
										type: 'success',
										callback: () => {
											this.dialogVisibleDeptModify = false;
											this.getDepartmentTreeData();
										}
									});
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		checkDept() {
			let keys = this.$refs.treeCheckDepartment.getCheckedKeys();
			console.log(keys);
			let nodes = this.$refs.treeCheckDepartment.getCheckedNodes();
			let departmentAdd = [];
			for (let i = 0; i < nodes.length; i++) {
				departmentAdd.push({ id: nodes[i].id, name: nodes[i].name, is_main: i == 0 ? true : false });
			}
			this.departmentAdd = departmentAdd;
			this.dialogVisibleCheckDepartment = false;
		},
		setMainDepartment(dept) {
			this.$confirm('确认设置【' + dept.name + '】为主部门？', '操作确认', {
				type: 'warning',
				callback: r => {
					if (r == 'confirm') {
						let departmentAdd = this.departmentAdd;
						for (let i = 0; i < departmentAdd.length; i++) {
							if (departmentAdd[i].id == dept.id) {
								departmentAdd[i].is_main = true;
							} else {
								departmentAdd[i].is_main = false;
							}
						}
						this.departmentAdd = departmentAdd;
						console.log(departmentAdd);
					}
				}
			});
		},
		delDepartment(dept) {
			this.$confirm('确认删除部门【' + dept.name + '】？', '操作确认', {
				type: 'warning',
				callback: r => {
					if (r == 'confirm') {
						let departmentAdd = [];
						for (let i = 0; i < this.departmentAdd.length; i++) {
							if (this.departmentAdd[i].id != dept.id) {
								departmentAdd.push(this.departmentAdd[i]);
							}
						}
						this.departmentAdd = departmentAdd;
						console.log(departmentAdd);
					}
				}
			});
		},
		addEmployeeSuccess(res) {
			console.log(res);
		},
		viewEmployeeInfo(id) {
			this.userId=id;
			this.employeeViewVisible=true;
		},
		modifyEmployee() {
			this.employeeViewVisible = false;
			this.dialogVisibleModify = true;
			this.formModifyEmployee = Object.assign({}, this.infoEmployee);
			console.log(this.formModifyEmployee);
		},
		checkDeptModify() {
			let nodes = this.$refs.treeCheckDepartmentModify.getCheckedNodes();
			console.log(nodes);
			let department = [];
			for (let i = 0; i < nodes.length; i++) {
				department.push({ id: nodes[i].id, name: nodes[i].name, is_main: i == 0 ? true : false });
			}
			this.formModifyEmployee.departmentArr = department;
			this.dialogVisibleCheckDepartmentModify = false;
		},
		setMainDepartmentModify(d) {
			this.$confirm('确认设置【' + d.name + '】为主部门？', '操作确认', {
				type: 'warning',
				callback: r => {
					if (r == 'confirm') {
						let department = this.formModifyEmployee.departmentArr;
						for (let i = 0; i < department.length; i++) {
							if (department[i].id == d.id) {
								department[i].is_main = true;
							} else {
								department[i].is_main = false;
							}
						}
						this.formModifyEmployee.departmentArr = department;
					}
				}
			});
		},
		delDepartmentModify(d) {
			this.$confirm('确认删除部门【' + d.name + '】？', '操作确认', {
				type: 'warning',
				callback: r => {
					if (r == 'confirm') {
						let department = [];
						let departmentArr = [];
						for (let i = 0; i < this.formModifyEmployee.departmentArr.length; i++) {
							if (this.formModifyEmployee.departmentArr[i].id != d.id) {
								department.push(this.formModifyEmployee.departmentArr[i].id);
								departmentArr.push(this.formModifyEmployee.departmentArr[i]);
							}
						}
						this.formModifyEmployee.department = department;
						this.$refs.treeCheckDepartmentModify.setCheckedKeys(department);
						this.formModifyEmployee.departmentArr = departmentArr;
					}
				}
			});
		},
		formSubmitModify() {
			this.$refs['formModifyEmployee'].validate(valid => {
				if (valid) {
					if (this.formModifyEmployee.departmentArr.length < 1) {
						this.$alert('请选择部门并设置主部门');
						return false;
					}
					let department = [];
					for (let i = 0; i < this.formModifyEmployee.departmentArr.length; i++) {
						if (this.formModifyEmployee.departmentArr[i].is_main) {
							this.formModifyEmployee.main_department = this.formModifyEmployee.departmentArr[i].id;
						}
						department.push(this.formModifyEmployee.departmentArr[i].id);
					}
					this.formModifyEmployee.department = department;
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=hr/department&a=modifyEmp', { data: this.formModifyEmployee }).then(
						res => {
							loading.close();
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$alert('修改人员信息成功！', {
										title: '操作成功',
										type: 'success',
										callback: () => {
											this.dialogVisibleModify = false;
											this.viewEmployeeInfo(this.formModifyEmployee.user_id);
											this.getEmployeeInfoList();
										}
									});
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		getDepartmentTreeData() {
			var that = this;
			this.loading = true;
			this.$http.post('/server/index.php?m=hr/department&a=getDepartmentTreeData', {}).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.departmentTreeData = res.data;
						this.handleNodeClick(res.data[0]);
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		handleDrop(draggingNode, dropNode, dropType, ev) {
			console.log('tree drop: ', dropNode.label, dropType);
			console.log(draggingNode);
			console.log(dropNode);
			console.log(ev);
		},
		handleNodeClick(e) {
			let department_info = Object.assign({}, e);
			delete department_info.children;
			this.department_info = department_info;
			this.formDeptModify = Object.assign({}, department_info);
			this.formSearch.data.department_id = department_info.id;
			this.getEmployeeInfoList();
			this.$refs.deptTree.setCurrentKey(department_info.id);
		},
		getEmployeeInfoList() {
			this.loading = true;
			this.$http.post('/server/index.php?m=hr/department&a=getEmployeeInfoList', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.employeeInfoList = res.data.infos;
						this.loading = false;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getEmployeeInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getEmployeeInfoList();
		}
	}
};
</script>

<style>
.tree-line .el-tree-node {
	position: relative;
	padding-left: 10px;
}
.tree-line .el-tree-node__children {
	padding-left: 10px;
}
.tree-line .el-tree-node::before {
	content: '';
	height: 100%;
	width: 1px;
	position: absolute;
	left: -3px;
	top: -26px;
	border-width: 1px;
	border-left: 1px dashed #ddd;
}
.tree-line .el-tree-node:last-child::before {
	height: 38px;
}
.tree-line .el-tree-node::after {
	content: '';
	width: 24px;
	height: 20px;
	position: absolute;
	left: -3px;
	top: 12px;
	border-width: 1px;
	border-top: 1px dashed #ddd;
}
.tree-line > .el-tree-node::after {
	border-top: none;
}
.tree-line > .el-tree-node::before {
	border-left: none;
}
.tree-line .el-tree-node__expand-icon {
	font-size: 10px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
	color: transparent;
}
.tree-menu.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #515a6e;
	color: #fff;
}
</style>
